import { render, staticRenderFns } from "./SafetyStatementsView.vue?vue&type=template&id=f88f809e&scoped=true"
import script from "./SafetyStatementsView.vue?vue&type=script&lang=js"
export * from "./SafetyStatementsView.vue?vue&type=script&lang=js"
import style0 from "./SafetyStatementsView.vue?vue&type=style&index=0&id=f88f809e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88f809e",
  null
  
)

export default component.exports